import {
    Module,
    VuexModule,
    getModule,
    Mutation,
} from 'vuex-module-decorators';
import store from '~common-store';
import { HomesEnergyState, HomeEnergy } from '~/interfaces/homeEnergy.interface';
import { HomesModule } from './homes';

@Module({ dynamic: true, store, name: 'homesEnergy', namespaced: true })
class HomesEnergy extends VuexModule implements HomesEnergyState {
    homesEnergy: HomeEnergy[] = [];


    @Mutation
    ADD_HOME_ENERGY(homeEnergy: HomeEnergy) {
        this.homesEnergy.push(homeEnergy);
    }
    get currentEnergyHome() {
        return this.homesEnergy.find((home) => home.homeId === HomesModule.currentHomeId);
    }

    get infos() {
        if (this.currentEnergyHome) {
            return [
                { key: 'heating_priority', value: this.currentEnergyHome.heating_priority, type: 'string' },
                { key: 'heating_energy', value: this.currentEnergyHome.heating_energy, type: 'string' },
                { key: 'home_type', value: this.currentEnergyHome.home_type, type: 'string' },
                { key: 'home_size', value: this.currentEnergyHome.home_size },
                {
                    key: 'open_window_detection',
                    value: this.currentEnergyHome.open_window_detection ? 'On' : 'Off', type: 'string',
                },
            ];
        }
    }

}

export const HomesEnergyModule = getModule(HomesEnergy);
